import { showErrorModal } from './showUIErrors'

export const handleActionValidationError = errors => {
	showErrorModal(
		Object.keys(errors)
			.filter(e => e !== 'non_field_errors')
			.map(key => `${key} - ${errors[key]}`)
	)
}
